import { Link, SmallText, greenBase } from "@RooUI";
import React from "react";

export const RegisterCTAText = () => {
  return (
    <>
      <SmallText data-testid="registerCTAText">
        By clicking "Create My Account", you agree to Roo's{" "}
        <Link href="https://www.roo.vet/terms-of-use" target="_blank" rel="noopener noreferrer">
          <SmallText color={greenBase}>Terms & Conditions</SmallText>
        </Link>{" "}
        and acknowledge that you have read our{" "}
        <Link href="https://www.roo.vet/privacy-policy" target="_blank" rel="noopener noreferrer">
          <SmallText color={greenBase}>Privacy Policy</SmallText>
        </Link>
        {"."}
      </SmallText>
    </>
  );
};
